// Components
import { useTable } from '@hooks/index';
import { summaryColumnsBuilder } from './SummaryTable.columns';
import { SummaryTableLayout } from './SummaryTable.layout';
// Types
import { SummaryTableProps, SummaryTableBody, SummaryColumnNames } from './SummaryTable.types';

/**
 * Component that is responsible for instance the table and makes some logic
 *
 * @param { SummaryTableProps }
 * @param {SummaryTableType} props.data - Data already parsed for the Summary Table.
 * @returns { ReactElement } - The SummaryTable Component
 */
const SummaryTable = ({ data }: SummaryTableProps) => {
  // Destructure the necessary data from the prop
  const { summaryTableData, eoyRatingTotal, total, ytdRatingTotal } = data;
  const columns = summaryColumnsBuilder({ eoyRatingTotal, total, ytdRatingTotal });

  // Use the `useTable` hook to create the table instance
  const { table } = useTable<SummaryTableBody, SummaryColumnNames>({
    columns,
    data: summaryTableData,
    isRowExpanded: true,
  });

  // Render the `SummaryTableLayout` component and pass the table instance as a prop
  return <SummaryTableLayout table={table} />;
};

export default SummaryTable;
